import { createTheme } from "@mui/material";

export const hexToRGBA = (h: string, opacity = 1): string => {
    let r = "";
    let g = "";
    let b = "";

    if (h.length === 4) {
        r = `0x${h[1]}${h[1]}`;
        g = `0x${h[2]}${h[2]}`;
        b = `0x${h[3]}${h[3]}`;
    } else if (h.length === 7) {
        r = `0x${h[1]}${h[2]}`;
        g = `0x${h[3]}${h[4]}`;
        b = `0x${h[5]}${h[6]}`;
    }

    return `rgba(${parseInt(r, 16)}, ${parseInt(g, 16)}, ${parseInt(b, 16)}, ${opacity})`;
};

export const theme = createTheme({
    typography: {
        fontFamily: "Plus Jakarta Sans, sans-serif",
    },
    palette: {
        primary: {
            light: "#2B3A51",
            dark: "#000000",
            main: "#00071A",
            contrastText: "#fff",
        },
        background: {
            default: "#F9FAFC",
        },
    },
    shape: {
        borderRadius: 8,
    },
    shadows: [
        "none",
        "0px 1px 2px rgba(0, 0, 0, 0.08)",
        "0px 1px 5px rgba(0, 0, 0, 0.08)",
        "0px 1px 8px rgba(0, 0, 0, 0.08)",
        "0px 1px 10px rgba(0, 0, 0, 0.08)",
        "0px 1px 14px rgba(0, 0, 0, 0.08)",
        "0px 1px 18px rgba(0, 0, 0, 0.08)",
        "0px 2px 16px rgba(0, 0, 0, 0.08)",
        "0px 3px 14px rgba(0, 0, 0, 0.08)",
        "0px 3px 16px rgba(0, 0, 0, 0.08)",
        "0px 4px 18px rgba(0, 0, 0, 0.08)",
        "0px 4px 20px rgba(0, 0, 0, 0.08)",
        "0px 5px 22px rgba(0, 0, 0, 0.08)",
        "0px 5px 24px rgba(0, 0, 0, 0.08)",
        "0px 5px 26px rgba(0, 0, 0, 0.08)",
        "0px 6px 28px rgba(0, 0, 0, 0.08)",
        "0px 6px 30px rgba(0, 0, 0, 0.08)",
        "0px 6px 32px rgba(0, 0, 0, 0.08)",
        "0px 7px 34px rgba(0, 0, 0, 0.08)",
        "0px 7px 36px rgba(0, 0, 0, 0.08)",
        "0px 8px 38px rgba(0, 0, 0, 0.08)",
        "0px 8px 40px rgba(0, 0, 0, 0.08)",
        "0px 8px 42px rgba(0, 0, 0, 0.08)",
        "0px 9px 44px rgba(0, 0, 0, 0.08)",
        "0px 9px 46px rgba(0, 0, 0, 0.08)",
    ],
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    letterSpacing: 0.75,
                },
                outlined: {
                    borderWidth: 2,
                    padding: "4px 14px",

                    "&:hover": {
                        borderWidth: 2,
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                outlined: {},
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    "& .MuiOutlinedInput-root": {
                        input: {
                            padding: "16.5px 20px",
                        },
                        "& fieldset": {
                            borderColor: "#D4D8E3",
                        },
                    },
                    "& .MuiInputLabel-outlined": {
                        color: "#8393A3",
                    },
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h4: {
                    fontWeight: 600,
                },
                h5: {
                    fontWeight: 600,
                },
                h6: {
                    fontWeight: 600,
                },
            },
        },
    },
});
